import * as React from 'react'
import Svg, { SvgProps, Defs, LinearGradient, Stop, G, Path, Text, TSpan, Circle, Rect } from 'react-native-svg'
import { Platform, TouchableOpacity, View } from 'react-native'
import { FontAwesomeIcon } from '../../FontAwesome/ColoredFontAwesomeIcon'
import { Toast } from 'native-base'
import { useState } from 'react'
/* SVGR has dropped some elements not supported by react-native-svg: title */
const AR_8 = ({
  props,
  report,
  year,
  giveFeedback,
  onClose,
}: {
  props?: SvgProps
  report: Record<string, any>
  year: number
  giveFeedback: (liked: boolean) => Promise<void>
  onClose: () => Promise<void>
}) => {
  const [feedbackSent, setFeedbackSent] = useState<boolean>(false)
  const reportFeedbackAvailable = report?.feedback !== undefined && report?.feedback !== null
  return (
    <>
      <Svg width={393} height={852} {...props}>
        <Defs>
          <LinearGradient id="a" x1="95.834%" x2="9.336%" y1="5.56%" y2="90.484%">
            <Stop offset="0%" stopColor="#74157C" />
            <Stop offset="100%" stopColor="#1D233A" />
          </LinearGradient>
        </Defs>
        <G fill="none" fillRule="evenodd">
          <Path fill="#FFF" d="M0 0h393v852H0z" />
          <Path fill="url(#a)" d="M52 0h1080v1080H52z" transform="translate(-310.97 -132)" />
          <Path
            fill="#0E0E1C"
            d="M84.506 343.5h674.38c63.776 0 115.477 43.428 115.477 97s-51.7 97-115.476 97H84.506c-63.776 0-115.476-43.428-115.476-97s51.7-97 115.476-97Z"
            opacity={0.202}
          />
          <Path
            fill="#FFF"
            d="M-164.278 248.589H821.03V776.5h-985.308c-152.6 0-146.661-122.45-146.661-273.5s0-254.411 146.661-254.411Z"
            opacity={0.02}
          />
          <Path
            fill="#000"
            d="m312.506-20.5 508.524-1v195H312.506c-63.776 0-115.476-43.428-115.476-97s51.7-97 115.476-97Z"
            opacity={0.269}
          />
          <Path
            fill="#FFF"
            fillRule="nonzero"
            d="M320.5 364.25h10.687a.51.51 0 0 0 .399-.187.624.624 0 0 0 .164-.422 10.913 10.913 0 0 0-1.594-5.203 11.31 11.31 0 0 0-3.844-3.844A10.913 10.913 0 0 0 321.11 353a.624.624 0 0 0-.422.164.51.51 0 0 0-.187.399v10.687Zm12.422 2.25h-10.688l7.547 7.547c.125.125.266.18.422.164a.684.684 0 0 0 .422-.211 10.983 10.983 0 0 0 2.039-3.234c.484-1.188.758-2.407.82-3.657a.624.624 0 0 0-.164-.421.51.51 0 0 0-.398-.188Zm-7.125 6.797-7.547-7.547v-10.687a.51.51 0 0 0-.188-.399.624.624 0 0 0-.421-.164 11.3 11.3 0 0 0-5.344 1.711 11.195 11.195 0 0 0-3.867 4.055c-.953 1.687-1.43 3.53-1.43 5.53 0 2 .508 3.86 1.523 5.58a11.465 11.465 0 0 0 4.102 4.1c1.719 1.016 3.594 1.524 5.625 1.524a11.175 11.175 0 0 0 7.547-2.906.595.595 0 0 0 .164-.375.506.506 0 0 0-.164-.422ZM70.5 503.25h10.687a.51.51 0 0 0 .399-.187.624.624 0 0 0 .164-.422 10.913 10.913 0 0 0-1.594-5.203 11.31 11.31 0 0 0-3.844-3.844A10.913 10.913 0 0 0 71.11 492a.624.624 0 0 0-.422.164.51.51 0 0 0-.187.399v10.687Zm12.422 2.25H72.234l7.547 7.547c.125.125.266.18.422.164a.684.684 0 0 0 .422-.211 10.983 10.983 0 0 0 2.039-3.234c.484-1.188.758-2.407.82-3.657a.624.624 0 0 0-.164-.421.51.51 0 0 0-.398-.188Zm-7.125 6.797-7.547-7.547v-10.687a.51.51 0 0 0-.188-.399.624.624 0 0 0-.421-.164 11.3 11.3 0 0 0-5.344 1.711 11.195 11.195 0 0 0-3.867 4.055c-.953 1.687-1.43 3.53-1.43 5.53 0 2 .508 3.86 1.523 5.58a11.465 11.465 0 0 0 4.102 4.1c1.719 1.016 3.594 1.524 5.625 1.524a11.175 11.175 0 0 0 7.547-2.906.595.595 0 0 0 .164-.375.506.506 0 0 0-.164-.422ZM269.571 102.571a2.572 2.572 0 0 1 2.572-2.571h1.714a2.572 2.572 0 0 1 2.572 2.571v18.858a2.572 2.572 0 0 1-2.572 2.571h-1.714a2.572 2.572 0 0 1-2.572-2.571V102.57ZM261 112.857a2.572 2.572 0 0 1 2.571-2.571h1.715a2.572 2.572 0 0 1 2.571 2.571v8.572a2.572 2.572 0 0 1-2.571 2.571h-1.715a2.572 2.572 0 0 1-2.571-2.571v-8.572Zm21.429-9.428A2.572 2.572 0 0 1 285 106v15.429a2.572 2.572 0 0 1-2.571 2.571h-1.715a2.572 2.572 0 0 1-2.571-2.571V106a2.572 2.572 0 0 1 2.571-2.571h1.715ZM341.571 685.571a2.572 2.572 0 0 1 2.572-2.571h1.714a2.572 2.572 0 0 1 2.572 2.571v18.858a2.572 2.572 0 0 1-2.572 2.571h-1.714a2.572 2.572 0 0 1-2.572-2.571V685.57ZM333 695.857a2.572 2.572 0 0 1 2.571-2.571h1.715a2.572 2.572 0 0 1 2.571 2.571v8.572a2.572 2.572 0 0 1-2.571 2.571h-1.715a2.572 2.572 0 0 1-2.571-2.571v-8.572Zm21.429-9.428A2.572 2.572 0 0 1 357 689v15.429a2.572 2.572 0 0 1-2.571 2.571h-1.715a2.572 2.572 0 0 1-2.571-2.571V689a2.572 2.572 0 0 1 2.571-2.571h1.715ZM93 716.174c0 .648-.552 1.174-1.232 1.174H71.232c-.68 0-1.232-.48-1.232-1.174 0-.648.552-1.174 1.186-1.174h2.89c.346-2.63 2.387-4.751 5.056-5.322.289-.988 1.192-1.678 2.368-1.678h3.193c1.192 0 2.285.768 2.51 1.882.257 1.5-.898 2.77-2.417 2.77H81.5c-.68 0-1.296-.263-1.74-.64-1.642.33-2.894 1.521-3.22 2.988h15.228c.683 0 1.232.567 1.232 1.174Zm-20.536 2.74h18.072l-1.48 12.693c-.093.793-.805 1.393-1.642 1.393H75.586c-.838 0-1.549-.6-1.641-1.393l-1.48-12.694Zm4.903 6.637 1.694 1.572-.397 2.226c-.078.403.372.703.744.513l2.092-1.051 2.092 1.051c.379.19.822-.11.744-.513l-.397-2.226 1.694-1.572a.486.486 0 0 0-.289-.837l-2.343-.33-1.046-2.024a.522.522 0 0 0-.918 0l-1.046 2.024-2.343.33a.485.485 0 0 0-.28.837ZM88 191.174c0 .648-.552 1.174-1.232 1.174H66.232c-.68 0-1.232-.48-1.232-1.174 0-.648.552-1.174 1.186-1.174h2.89c.346-2.63 2.387-4.751 5.056-5.322.289-.988 1.192-1.678 2.368-1.678h3.193c1.192 0 2.285.768 2.51 1.882.257 1.5-.898 2.77-2.417 2.77H76.5c-.68 0-1.296-.263-1.74-.64-1.642.33-2.894 1.521-3.22 2.988h15.228c.683 0 1.232.567 1.232 1.174Zm-20.536 2.74h18.072l-1.48 12.693c-.093.793-.805 1.393-1.642 1.393H70.586c-.838 0-1.549-.6-1.641-1.393l-1.48-12.694Zm4.903 6.637 1.694 1.572-.397 2.226c-.078.403.372.703.744.513l2.092-1.051 2.092 1.051c.379.19.822-.11.744-.513l-.397-2.226 1.694-1.572a.486.486 0 0 0-.289-.837l-2.343-.33-1.046-2.024a.522.522 0 0 0-.918 0l-1.046 2.024-2.343.33a.485.485 0 0 0-.28.837Z"
            opacity={0.292}
          />
          <Text fill="#FFF" fontFamily={'Comfortaa_700Bold'} fontSize={24} fontWeight="normal" fillRule="nonzero">
            <TSpan x={73.592} y={299}>
              {'Sei stolz auf deinen'}
            </TSpan>
            <TSpan x={160.556} y={331}>
              {'Shop! '}
            </TSpan>
            <TSpan x={64.028} y={430}>
              {'dash.'}
            </TSpan>
            <TSpan x={132.236} y={430} fontFamily={'Comfortaa_500Medium'} fontWeight="normal" fillRule="nonzero">
              {'bar'}
            </TSpan>
            <TSpan x={176.444} y={430}>
              {' w\xFCnscht dir '}
            </TSpan>
            <TSpan x={76.292} y={465}>
              {`f\xFCr ${year + 1} viel Erfolg!`}
            </TSpan>
            {reportFeedbackAvailable === false && feedbackSent === false && (
              <>
                <TSpan x={122} y={593} fontFamily={'Comfortaa_500Medium'} fontWeight="normal" fillRule="nonzero">
                  {'Hat dir dein '}
                </TSpan>
                <TSpan x={36.716} y={625} fontFamily={'Comfortaa_500Medium'} fontWeight="normal" fillRule="nonzero">
                  {'Jahresr\xFCckblick gefallen? '}
                </TSpan>
              </>
            )}
          </Text>
          <G transform="translate(351 50)" onPress={onClose}>
            <Circle cx={14.5} cy={14.5} r={14.5} fill="#1E2239" />
            <Path
              fill="#FFF"
              fillRule="nonzero"
              d="M21.711 21.228a1.25 1.25 0 1 1-1.92 1.6l-5.29-6.38-5.29 6.347a1.247 1.247 0 0 1-1.76.16 1.25 1.25 0 0 1-.16-1.76l5.582-6.7L7.29 7.83a1.25 1.25 0 1 1 1.92-1.6l5.29 6.346 5.29-6.348a1.249 1.249 0 1 1 1.92 1.6l-5.583 6.7 5.584 6.7Z"
            />
          </G>
          <G fill="#D8D8D8" transform="translate(10 60.596)">
            <Rect width={36.056} height={4.807} rx={2.404} />
            <Rect width={36.056} height={4.807} x={42.065} rx={2.404} />
            <Rect width={36.056} height={4.807} x={84.13} rx={2.404} />
            <Rect width={36.056} height={4.807} x={126.195} rx={2.404} />
            <Rect width={36.056} height={4.807} x={167.659} rx={2.404} />
            <Rect width={36.056} height={4.807} x={209.711} rx={2.404} />
            <Rect width={36.056} height={4.807} x={250.827} rx={2.404} />
            <Rect width={36.056} height={4.807} x={291.944} rx={2.404} />
          </G>
          <Text fill="#FFF" fontFamily={'Comfortaa_700Bold'} fontSize={40} fontWeight="normal" fillRule="nonzero">
            <TSpan x={10} y={129}>
              {'Danke'}
            </TSpan>
          </Text>

          {/* <Path
          fill="#FFF"
          fillRule="nonzero"
          d="M254.5 692.93v-17.5c0-1.38-1.12-2.43-2.5-2.43h-5c-1.38 0-2.5 1.12-2.5 2.43v17.43c0 1.38 1.12 2.43 2.5 2.43h5c1.383.14 2.5-.915 2.5-2.36Zm30-17.422a3.749 3.749 0 0 0-3.75-3.749h-11.445c1.779-2.961 2.697-6.318 2.697-7.501-.002-1.842-1.447-3.758-3.87-3.758-4.931 0-2.059 5.95-8.452 11.063l-1.274 1.015a3.765 3.765 0 0 0-1.398 2.922c-.002.002 0 0 0 0L257 688c0 1.18.556 2.291 1.5 3l2.667 1.998a12.465 12.465 0 0 0 7.497 2.502h4.586a3.748 3.748 0 0 0 3.75-3.748c0-.284-.038-.558-.097-.825 1.503-.49 2.597-1.88 2.597-3.552 0-.715-.21-1.376-.558-1.944a3.743 3.743 0 0 0 3.058-3.673c0-.977-.382-1.858-.994-2.525a3.739 3.739 0 0 0 3.494-3.725ZM139.5 672.07v17.5c0 1.38-1.12 2.43-2.5 2.43h-5c-1.38 0-2.5-1.12-2.5-2.43v-17.43c0-1.38 1.12-2.43 2.5-2.43h5c1.383-.14 2.5.915 2.5 2.36Zm30 17.422a3.749 3.749 0 0 1-3.75 3.749h-11.445c1.779 2.961 2.697 6.318 2.697 7.501-.002 1.842-1.447 3.758-3.87 3.758-4.931 0-2.059-5.95-8.452-11.063l-1.274-1.015a3.765 3.765 0 0 1-1.398-2.922c-.002-.002 0 0 0 0L142 677c0-1.18.556-2.291 1.5-3l2.667-1.998a12.465 12.465 0 0 1 7.497-2.502h4.586a3.748 3.748 0 0 1 3.75 3.748c0 .284-.038.558-.097.825 1.503.49 2.597 1.88 2.597 3.552 0 .715-.21 1.376-.558 1.944a3.743 3.743 0 0 1 3.058 3.673c0 .977-.382 1.858-.994 2.525a3.739 3.739 0 0 1 3.494 3.725Z"
        /> */}
        </G>
      </Svg>
      {reportFeedbackAvailable === false && feedbackSent === false && (
        <View
          style={{
            top: 650,
            position: 'absolute',
            flex: 1,
            flexDirection: 'row',
            justifyContent: 'space-evenly',
            alignContent: 'center',
            alignItems: 'center',
            width: 393,
            height: 50,
          }}
        >
          <TouchableOpacity
            onPress={(e) => {
              setFeedbackSent(true)
              giveFeedback(false).then(() => {
                Toast.show({ title: `Danke für dein Feedback!` })
              })
              e.stopPropagation()
            }}
          >
            {/*@ts-expect-error Icon error*/}
            <FontAwesomeIcon icon={'thumbs-down'} size={40} color={`#FFF`} />
          </TouchableOpacity>
          <TouchableOpacity
            onPress={(e) => {
              setFeedbackSent(true)
              giveFeedback(true).then(() => {
                Toast.show({ title: `Danke für dein Feedback!` })
              })
              e.stopPropagation()
            }}
          >
            {/*@ts-expect-error Icon error*/}
            <FontAwesomeIcon icon={'thumbs-up'} size={40} color={`#FFF`} />
          </TouchableOpacity>
        </View>
      )}
      {Platform.OS === 'web' && (
        <TouchableOpacity
          onPress={onClose}
          style={{ position: 'absolute', top: 50, marginLeft: 330, width: 50, height: 50 }}
        />
      )}
    </>
  )
}
export default AR_8
